import React from "react";
import { keycloak } from "../../lib/keycloak/index.ts";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook.ts";
import { SearchIcon } from "../../ui/icons/searchIcon.tsx";
import { ButtonComponent } from "../../ui/molecules/button/index.tsx";
import { InputComponent } from "../../ui/molecules/input/index.tsx";
import { SelectComponent } from "../../ui/molecules/select/index.tsx";
import { CompanyStatus } from "./dto.ts";
import { findAllCompany, setCompanyFiltersCompanyName, setCompanyFiltersFinancialAdvisorId, setCompanyFilterStatus } from "./slice.ts";

export function CompanyFilters() {
    const dispatch = useAppDispatch()
    const companyState = useAppSelector(state => state.company)
    const financialAdvisorState = useAppSelector(state => state.financialAdvisor)

    return (
        <div className={"flex flex-row gap-4 w-full"}>
            <div className={"flex flex-row gap-4 w-full"}>
                <InputComponent
                    placeholder="Cerca azienda"
                    startIcon={<SearchIcon />}
                    type={"text"}
                    onChangeText={(value) => dispatch(setCompanyFiltersCompanyName(value))}
                    value={companyState.companyFilters.companyName}
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            dispatch(findAllCompany(companyState.companyFilters))
                        }
                    }}
                />
                {
                    !keycloak.hasRealmRole('financial_advisor') &&
                    <SelectComponent
                        placeholder="Tutti i commercialisti"
                        onChange={(value) => {
                            dispatch(findAllCompany({
                                itemsPerPage: companyState.companyFilters.itemsPerPage,
                                page: companyState.companyFilters.page,
                                financialAdvisorId: value as string,
                                sort: companyState.companyFilters.sort,
                                companyName: companyState.companyFilters.companyName,
                                order: companyState.companyFilters.order,
                                status: companyState.companyFilters.status
                            }))
                            dispatch(setCompanyFiltersFinancialAdvisorId(value))
                        }}
                        options={financialAdvisorState.findAllFinancialAdvisorResponse?.data.map((value) => ({ label: (value.commercialName.trim()? value.commercialName : (value.name + " " + value.surname)), value: value.id }))!}
                        value={companyState.companyFilters.financialAdvisorId}
                    />
                }
                <div className={"w-1/4"}>
                    <SelectComponent
                        placeholder="Stato"
                        onChange={(e) => {
                            dispatch(findAllCompany({
                                itemsPerPage: companyState.companyFilters.itemsPerPage,
                                page: companyState.companyFilters.page,
                                financialAdvisorId: companyState.companyFilters.financialAdvisorId,
                                sort: companyState.companyFilters.sort,
                                companyName: companyState.companyFilters.companyName,
                                order: companyState.companyFilters.order,
                                status: e!
                            }))
                            dispatch(setCompanyFilterStatus(e))
                        }}
                        options={[
                            { value: CompanyStatus.ACTIVE, label: "Attiva" },
                            { value: CompanyStatus.SUSPENDED, label: "Archiviata" }
                        ]}
                        value={companyState.companyFilters.status}
                    />
                </div>
            </div>
            <div className={"gap-2 flex flex-row"}>
                <ButtonComponent
                    label="Pulisci"
                    size={"md"}
                    iconPosition={"off"}
                    variant={"outline"}
                    color={"gray"}
                    onClick={() => {
                        dispatch(setCompanyFiltersCompanyName(""))
                        dispatch(setCompanyFiltersFinancialAdvisorId(""))
                        dispatch(setCompanyFilterStatus(""))
                        dispatch(findAllCompany({
                            itemsPerPage: companyState.companyFilters.itemsPerPage,
                            page: companyState.companyFilters.page,
                            financialAdvisorId: "",
                            sort: companyState.companyFilters.sort,
                            companyName: "",
                            order: companyState.companyFilters.order,
                            status: ""
                        }))
                    }}
                />
                <ButtonComponent
                    label="Applica"
                    size={"md"}
                    iconPosition={"off"}
                    variant={"outline"}
                    color={"blue"}
                    onClick={() => {
                        dispatch(findAllCompany({
                            itemsPerPage: companyState.companyFilters.itemsPerPage,
                            page: companyState.companyFilters.page,
                            financialAdvisorId: companyState.companyFilters.financialAdvisorId,
                            sort: companyState.companyFilters.sort,
                            companyName: companyState.companyFilters.companyName,
                            order: companyState.companyFilters.order,
                            status: companyState.companyFilters.status
                        }))
                    }}
                />
            </div>
        </div>
    )
}